import { randomNumericId } from '@/lib/utils/crypto/client/crypto'

export const NEW_RELIC_HEADERS = {
  traceparent: 'traceparent',
  traceId: 'x-trace-id',
  correlationId: 'x-correlation-id',
  parentId: 'x-parent-id',
  requestId: 'x-request-id',
}

export function generateCorrelationId(): string {
  return randomNumericId(16)
}
